import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BottomNav from './components/BottomNav';

import ConditionalHome from './views/ConditionalHome';
import FeedView from './views/FeedView';
import PrivacyPolicy from './views/PrivacyPolicy';
import TermsService from './views/TermsService';
import AdPolicy from './views/AdPolicy';
import Support from './views/Support';
import NearbyPlayers from './views/NearbyPlayers';
import BusinessSearchView from './views/BusinessSearchView';
import LoginView from './views/LoginView';
import CreatePostModal from './views/CreatePostModal';
import PostManagerModal from './views/PostManagerModal';
import FavoritesModal from './views/FavoritesModal';
import SettingsModal from './views/SettingsModal';
import ProfilePage from './views/ProfilePage';
import ShoparoundView from './views/ShoparoundView';
import NotFound from './views/NotFound';
import BucksHouseView from './views/BucksHouseView';
import RaceRoomPage from './views/RaceRoomPage';
import DeleteAccount from './views/DeleteAccount';
import ChildSafetyStandards from './views/ChildSafetyStandards';
import AppDownloadPage from './pages/AppDownloadPage';
import SearchLandingPage from './pages/seo/SearchLandingPage';
import TeamDetailPage from './views/teams/TeamDetailPage';
import TournamentDetailPage from './views/tournaments/TournamentDetailPage';
import BusinessOperationsPage from './views/business/BusinessOperationsPage';
import BookingsPage from './views/bookings/BookingsPage';
import MessagesPage from './views/messages/MessagesPage';
import SafetyCenterPage from './views/safety/SafetyCenterPage';
import RouteAnalytics from './components/analytics/RouteAnalytics';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import NotificationSetupPrompt from './components/NotificationSetupPrompt';
import NotificationBridge from './components/NotificationBridge';

import './App.css';
import './components/P4RFormSystem.css';

function AppContent() {
  return (
    <>
      <RouteAnalytics />
      <ScrollToTop />
      <NotificationBridge />
      <NotificationSetupPrompt />
      <Navbar />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<ConditionalHome />} />
          <Route path="/feed" element={<FeedView />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/termsofservice" element={<TermsService />} />
          <Route path="/adpolicy" element={<AdPolicy />} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/delete-account" element={<ProtectedRoute><DeleteAccount /></ProtectedRoute>} />
          <Route path="/child-safety-standards" element={<ChildSafetyStandards />} />
          <Route path="/child-safety" element={<ChildSafetyStandards />} />
          <Route path="/account-deletion" element={<ProtectedRoute><DeleteAccount /></ProtectedRoute>} />
          <Route path="/players" element={<ProtectedRoute><NearbyPlayers /></ProtectedRoute>} />
          <Route path="/map" element={<BusinessSearchView />} />
          <Route path="/login" element={<LoginView />} />
          <Route path="/shoparound" element={<ShoparoundView />} />
          <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
          <Route path="/bookings" element={<ProtectedRoute><BookingsPage /></ProtectedRoute>} />
          <Route path="/business/manage" element={<ProtectedRoute><BusinessOperationsPage /></ProtectedRoute>} />
          <Route path="/safety" element={<ProtectedRoute><SafetyCenterPage /></ProtectedRoute>} />
          <Route path="/create-event" element={<ProtectedRoute><BusinessOperationsPage /></ProtectedRoute>} />

          <Route path="/bucks" element={<ProtectedRoute><BucksHouseView /></ProtectedRoute>} />
          <Route path="/bucks/teams/:teamId" element={<ProtectedRoute><TeamDetailPage /></ProtectedRoute>} />
          <Route path="/bucks/tournaments/:tournamentId" element={<ProtectedRoute><TournamentDetailPage /></ProtectedRoute>} />
          <Route path="/teams" element={<Navigate to="/bucks" replace />} />
          <Route path="/teams/:teamId" element={<ProtectedRoute><TeamDetailPage /></ProtectedRoute>} />
          <Route path="/tournaments" element={<Navigate to="/bucks?tab=tournaments" replace />} />
          <Route path="/tournaments/:tournamentId" element={<ProtectedRoute><TournamentDetailPage /></ProtectedRoute>} />
          <Route path="/race-room" element={<ProtectedRoute><RaceRoomPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />

          <Route path="/download" element={<AppDownloadPage />} />
          <Route path="/ios" element={<AppDownloadPage />} />
          <Route path="/android" element={<AppDownloadPage />} />
          <Route path="/android-beta" element={<AppDownloadPage />} />
          <Route path="/find-pool-players-near-me" element={<SearchLandingPage pageKey="players" />} />
          <Route path="/pool-tournaments-near-me" element={<SearchLandingPage pageKey="tournaments" />} />
          <Route path="/pool-halls-near-me" element={<SearchLandingPage pageKey="halls" />} />
          <Route path="/pool-scorekeeper" element={<SearchLandingPage pageKey="scorekeeper" />} />
          <Route path="/pool-practice-room" element={<SearchLandingPage pageKey="practice" />} />
          <Route path="/pool-match-tracker" element={<SearchLandingPage pageKey="tracker" />} />
          <Route path="/organize-pool-matches" element={<SearchLandingPage pageKey="matches" />} />
          <Route path="/pool-teams" element={<SearchLandingPage pageKey="teams" />} />
          <Route path="/pool-hall-management" element={<SearchLandingPage pageKey="business" />} />
          <Route path="/buy-sell-pool-equipment" element={<SearchLandingPage pageKey="marketplace" />} />
          <Route path="/billiards-community" element={<SearchLandingPage pageKey="community" />} />

          <Route path="/addpost" element={<ProtectedRoute><CreatePostModal onClose={() => window.history.back()} /></ProtectedRoute>} />
          <Route path="/manage-posts" element={<ProtectedRoute><PostManagerModal onClose={() => window.history.back()} /></ProtectedRoute>} />
          <Route path="/favorites" element={<ProtectedRoute><FavoritesModal onClose={() => window.history.back()} /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><SettingsModal show onClose={() => window.history.back()} /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <BottomNav />
      <Footer />
    </>
  );
}

export default function App() {
  return <Router><AppContent /></Router>;
}
